import { v4 as guidv4 } from 'uuid';

export function guid() { return guidv4(); }